/**
 * KeyIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const KeyIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M18.31 3.811a5.2 5.2 0 0 0-7.22 7.11L3 19.001l1.71 1.71 2.67-2.71 2.69 2.68 1.7-1.68-2.69-2.67 3.71-3.71a5.2 5.2 0 0 0 5.52-8.81m-.82 6.37a2.8 2.8 0 0 1-4 0 2.8 2.8 0 0 1 2-4.78 2.76 2.76 0 0 1 2 .82 2.81 2.81 0 0 1 0 3.96" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const KeyIcon = makeIcon('KeyIcon', KeyIconSvg)
